<template>
    <div class="cpo-header">
        <div class="cpo-header--root">
            <span class="cpo-header--headline" v-html="content.headline"></span>
            <hr class="cpo-header--hr">
            <h1 class="cpo-header--title" v-text="content.title"></h1>
        </div>
    
        <div class="cpo-header--badge">
            <div class="cpo-header--badge-text" v-html="linebreak(content.bubble)"></div>
        </div>
        
        <!-- <pre v-if="content" v-text="content"></pre> -->
    </div>
</template>

<script>
    import { mapFilters } from 'util/vue/map-filters';
    
    
    export default {
        props: {
            content: Object,
        },
        methods: {
            ...mapFilters(['linebreak']),
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?5978c733